export default __webpack_public_path__ + "static/media/el_0.e432e390.mp3";